import { render, staticRenderFns } from "./GupshupApiKey.vue?vue&type=template&id=32508788&scoped=true&"
import script from "./GupshupApiKey.vue?vue&type=script&lang=js&"
export * from "./GupshupApiKey.vue?vue&type=script&lang=js&"
import style0 from "./GupshupApiKey.vue?vue&type=style&index=0&id=32508788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32508788",
  null
  
)

export default component.exports